// components/ImagePopup.jsx
import React from 'react';
import { X } from 'lucide-react';

const ImagePopup = ({ showImagePopup, setShowImagePopup, selectedImage, getImageUrl }) => {
  if (!showImagePopup || !selectedImage) return null;

  return (
    <div 
      className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-2 sm:p-4"
      onClick={() => setShowImagePopup(false)}
    >
      <button 
        className="absolute top-2 right-2 sm:top-4 sm:right-4 text-white p-2 hover:bg-white/10 rounded-full transition-colors"
        onClick={() => setShowImagePopup(false)}
      >
        <X className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>
      <img
        src={getImageUrl(selectedImage)}
        alt="Full size"
        className="max-w-full max-h-[90vh] object-contain rounded-lg"
        onClick={e => e.stopPropagation()}
      />
    </div>
  );
};

export default ImagePopup;